import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './static/main.css'

import ArrayExtends from "@/lib/ArrayExetends";

ArrayExtends()

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.filter("blankFmt", function (v) {
    if (typeof v !== 'string') {
        return v
    }
    if (v && v.trim()) {
        return v
    }
    return '-'
})

Vue.filter("fmtBoolean", function (v) {
    return v ? "是" : "否"
})

const app = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

export default app
